// extracted by mini-css-extract-plugin
module.exports = {"item":"item--1YUNz","iconWrap":"iconWrap--I5Hrq","icon":"icon--139Ol","title":"title--2L6dB","describe":"describe--7W-Bu","moduleItem":"moduleItem--XcYyl"};